import React from 'react';
import NewAppIFrame from 'components/NewAppIFrameViewer';


const CompletionLog = () => {
  return (
    <NewAppIFrame
      iFramePagePath={"analytics/completion-logs"}
      title="Completion Log"
    />
  );
};
export default CompletionLog;